import {createContext, useContext} from 'react';

const HQSettingsContext = createContext();

const HQSettingsProvider = ({children, value}) => {
  return <HQSettingsContext.Provider value={value}>{children}</HQSettingsContext.Provider>;
};

const useHqSettings = () => {
  const context = useContext(HQSettingsContext);
  if (context === undefined) {
    throw new Error('useHqSettings must be used within a HQSettingsProvider');
  }
  return context;
};

export {useHqSettings, HQSettingsProvider};
